





























































































































































































import {Vue, Component, Ref, Watch} from 'vue-property-decorator';
import {SelectWings, Througoutput } from "wings-ui-components";
import {Action, Getter} from "vuex-class";
import {AccountItem, AccountItemImpl} from "@/store/settings/accounts/types";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

Component.registerHooks([
  'beforeRouteLeave',
])

@Component({components: {SelectWings, Througoutput}})
export default class Account extends Vue {
  @Ref('validator') validator: any;
  @Getter("transports") transportsList: any;
  // @Getter("partners") partnersList: any;
  @Getter("protocolList") protocolList: any;
  @Action("getTransports") actionGetTransports: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getAccountItem") actionGetItem: any;
  @Action("saveAccount") actionSave: any;
  @Action("deleteAccount") actionDelete: any;
  @Action("actionLog") actionLog: any;

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {};
  partnersList: any = []

  defaultItem(): AccountItem {
    return new AccountItemImpl()
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners(filter);
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Account",
        }
        this.logObject.object_name = this.item.login;
        const data = await this.actionGetItem(this.$route.params.id);
        await this.actionLog(this.logObject);
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
        this.partnersList = await this.actionGetPartners({id: this.item.partner_id});
      } catch(error) {
        this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
        this.back();
      }
    }
    this.actionGetTransports();
  }

  back(): void {
    this.$router.push('/settings/accounts/');
  }

  async onSaveItem(): Promise<void> {
    let valid:boolean = await this.validator.validate();
    if (valid) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: this.$route.params.id ? "Editing" : "Creation",
          action_status: "success",
          object_type: "Account",
          object_name : this.item.login,
          addititional_info: getTranslatedParams(this.item)
        }
        await this.actionSave(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
        throw error
      }
    } else {
      setTimeout(() => {
        notifyError(null, this.validator.errors)
      }, 100);
      throw new Error('Validation Error')
    }
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Account",
          object_name : this.item.login,
          addititional_info: getTranslatedParams({id: this.item.id})
        }
        await this.actionDelete(this.item)
        await this.actionLog(this.logObject)
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  onInputPassword(event:any) {
    this.item.password = event
    this.$emit('input', event)
  }

  onInputConfirmPassword(event:any) {
    this.item.confirm_password = event
    this.$emit('input', event)
  }

  @Watch('item.protocol_id', { immediate: true })
  onChangeProtocolId(val:number, oldVal?: number){
    if (oldVal && val === 1) {
      this.item.transport_id = null
      this.item.max_throughput = ''
      this.item.immediate_response_needed = 1
    }
    if (oldVal && val === 2) {
      this.item.push_statuses = 0
      this.item.url = null
      this.item.status_report = 0
      this.item.max_throughput = '10/1000'
    }
  }

  get transportsForAccounts() {
    return this.transportsList?.filter((value:any) => value.name.toLowerCase() === 'sms'
      || value.name.toLowerCase() === 'call')
  }

  get status():number {
    return this.item.status
  }

  set status(value:number) {
    this.item.status = (value ?? 0)
  }

  get push_statuses():number {
    return this.item.push_statuses || 0
  }

  set push_statuses(value:number) {
    if (value!==1) {
      this.item.url = undefined
    }
    this.item.push_statuses = (value ?? 0)
  }

  get immediate_response_needed():number {
    return this.item.immediate_response_needed || 0
  }

  set immediate_response_needed(value:number) {
    this.item.immediate_response_needed = (value ?? 0)
  }
}
